// extracted by mini-css-extract-plugin
var _1 = "styles-module__buttonsContainer___XaoGQ";
var _2 = "styles-module__colorDistanceSpacer____aKOv";
var _3 = "styles-module__container___uMiw3";
var _4 = "styles-module__routeFormHeader___Q7JFV";
var _5 = "styles-module__sectionTitle___HmMB1";
export { _1 as "buttonsContainer", _2 as "colorDistanceSpacer", _3 as "container", _4 as "routeFormHeader", _5 as "sectionTitle" }
